import { useRef } from "react";

export const useUploadInput = () => {
  const uploadInputRef = useRef<HTMLInputElement | null>(null);

  const handleInputKeydown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    event.preventDefault();
  };

  const handleUploadButtonClick = () => {
    uploadInputRef.current?.click();
  };

  return {
    uploadInputRef,
    handleInputKeydown,
    handleUploadButtonClick,
  };
};
